import React from "react";

function View(props, { locals }) {
  return (
    <div id="login-wrapper">
      <img
        className="logo"
        src="/img/msb-logo-white.svg"
        alt="My Stength Book"
      />
      <div className="frame">
        <h1 className="alt">Terms of Use</h1>
        <p>
          You may not alter, use, transmit, repurpose, sell, copy, distribute or
          display any portions of the MyStrengthBook website without written
          consent from MyStrengthBook. This includes all graphics and site
          content.
        </p>
        <p>
          MyStrengthBook does not warrant or make any representations or claims
          as to the validity, correctness, currency or otherwise of the
          information provided at this site, nor shall it be liable or
          responsible for any claim or damage, direct or consequential, arising
          out of the interpretation, failure of performance, error in content,
          delay in operation of site, computer virus, reliance upon or other
          use, authorized or unauthorized, of such information.
        </p>
        <p>
          Certain links on this site lead to sites maintained by independent
          parties over whom MyStrengthBook has no control. MyStrengthBook makes
          no representation to the accuracy or any other aspect of the
          information contained on such sites.
        </p>
        <p>
          MyStrengthBook is not responsible for any losses incurred as the
          result of your decision to use our product or any third party services
          that our product uses. You are responsible for determining the
          suitability of our product for your needs.
        </p>
        <p>
          MyStrengthBook reserves the right to modify our Terms of Use policy at
          any time.
        </p>
        <p>
          If you have any questions about our terms of use or privacy policy, or
          would like more information about MyStrengthBook, or are experiencing
          technical trouble, please{" "}
          <a href="mailto:info@mystrengthbook.com">contact us</a>.
        </p>
      </div>
    </div>
  );
}

const TermsOfUse = (app) => {
  app.get("/terms-of-use", ({ res }) => (res.body = <View />));
};

export default TermsOfUse;
